import { inject, Injectable } from '@angular/core';
import { AdyenHostedResultResponse, CreateAdyenSessionRequest, CreateAdyenSessionResponse } from '@models/adyen.model';
import { StripSubscriptionDetails } from '@models/stripe-token.model';
import { HttpClientService } from '@services/utils/http-client.service';
import { PaymentIntent } from '@stripe/stripe-js';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  private httpClientService = inject(HttpClientService);

  /**
   * Mint an Adyen payment session. The response carries only session handles
   * and the PUBLIC client key — the API and HMAC keys stay on the backend.
   */
  createAdyenSession(payload: CreateAdyenSessionRequest): Observable<CreateAdyenSessionResponse> {
    return this.httpClientService.post('adyen/sessions', payload, {});
  }

  /**
   * Whether the shopper has come back from Adyen's hosted page for this session. Answers only for
   * the nonce AND the token the session was minted with (anything else is a 404) - the popup's
   * postMessage is the fast path, this is the one that still works when the partner's page never
   * receives it.
   */
  getAdyenHostedResult(nonce: string, token: string): Observable<AdyenHostedResultResponse> {
    return this.httpClientService.get('adyen/hosted-result', { params: { n: nonce, t: token } });
  }

  createPaymentIntent(subscriptionDetails: StripSubscriptionDetails): Observable<PaymentIntent> {
    return this.httpClientService.post('payment-intents/create', subscriptionDetails, {});
  }

  updatePaymentIntent(subscriptionDetails: StripSubscriptionDetails): Observable<PaymentIntent> {
    return this.httpClientService.post('payment-intents/update', subscriptionDetails, {});
  }
}
